import {
    Hash,
    Chain,
} from "viem";
import {useEffect, useState} from "react";
import ModalDrawer from "../ModalDrawer";
import Button from "../Button";
import {Lottie} from "../../ui";
import {successImg, failImg, confirmImg,pendingImg} from "assets/lottie";
import useHash from "../../hooks/useHash";

type statusType = 'pending' | 'success' | 'fail' | 'confirm'
type HashPanelProps = {
    hash?: Hash | null,
    chain?: Chain | null,
    isOpen: boolean,
    onClose: () => void
    zIndex?: number,
    error?: string
}

function HashPanel({
                       hash,
                       chain,
                       isOpen,
                       onClose,
                       zIndex,
                       error
                   }: HashPanelProps) {
    const [status, setStatus] = useState<statusType>('confirm')

    const statusMaps: Record<statusType, {
        text: string;
        color: string
        lottie?: any
    }> = {
        'confirm': {
            text: 'Confirming...',
            color: '#FC802D',
            lottie: confirmImg
        },
        'pending': {
            lottie: pendingImg,
            text: 'Pending...',
            color: '#FC802D'
        },
        'success': {
            text: 'Successful!',
            color: '#2CBF68',
            lottie: successImg
        },
        'fail': {
            text: 'Failed!',
            color: '#F14141',
            lottie: failImg
        }
    }

    const statusValue = error ? statusMaps.fail : statusMaps[status]
    const [shouldRefetch, setShouldRefetch] = useState(true)

    useEffect(() => {
        if (hash) {
            setShouldRefetch(true)
            setStatus('pending')
        } else {
            setStatus('confirm')
        }
    }, [hash])
    const hashQuery = useHash({
        hash,
        chain,
        refetchInterval: shouldRefetch ? 3000 : false
    })
    useEffect(() => {
        if (hashQuery.data == 1 || hashQuery.data == -1) {
            setShouldRefetch(false)
        }
        if (hashQuery.data == 1) {
            setStatus('success')
        } else if (hashQuery.data == -1) {
            setStatus('fail')
        } else if (hashQuery.data == 0) {
            setStatus('pending')
        }
    }, [hashQuery.data]);

    const link = chain ? `${chain?.blockExplorers?.default.url}/tx/${hash}` : '';

    return <ModalDrawer isOpen={isOpen}
                        showClose
                        onClose={onClose}
                        zIndex={zIndex}
                        title={
                            <div className={"matchid-hashpanel-header"}
                                 style={{
                                     color: statusValue.color
                                 }}>{statusValue.text}</div>
                        }
    >
        <div className="matchid-hashpanel-box">
            <div className="matchid-hashpanel-content">
                <div className={`matchid-hashpanel-status`} style={{
                    color: statusValue.color
                }}>{statusValue.text}</div>
                {
                    statusValue.lottie  && <Lottie animationData={statusValue.lottie} style={{
                        width: "96px",
                        height: "96px",
                    }}/>
                }

                {hash && <div className="matchid-hashpanel-hash">
                    Hash:<a href={link} target="_blank">{hash}</a>
                </div>}
                {error && <div className="matchid-hashpanel-text">
                    {error}
                </div>}
            </div>
            <Button onClick={onClose} size="lg" block>Back</Button>
        </div>
    </ModalDrawer>
}

export default function (props: HashPanelProps) {
    return props.isOpen && <HashPanel {...props}/>

}